import { Link, Outlet, useNavigate } from "react-router-dom";
import { apiClient } from "../../lib/api-client";

export function AdminDashboardPage() {
  const navigate = useNavigate();
  const token = typeof window !== "undefined" ? localStorage.getItem("datasci_admin_token") : null;
  const userJson = typeof window !== "undefined" ? localStorage.getItem("datasci_admin_user") : null;
  const user = userJson ? JSON.parse(userJson) : null;

  async function handleLogout() {
    try {
      await apiClient.post("/admin/auth/logout");
    } catch {
      // Ignora erro de rede no logout
    }
    localStorage.removeItem("datasci_admin_token");
    localStorage.removeItem("datasci_admin_user");
    navigate("/login?perfil=admin");
  }

  return (
    <div>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "var(--space-2)" }}>
        <h1>Administração Datasci</h1>
        <div style={{ display: "flex", alignItems: "center", gap: "var(--space-3)" }}>
          {token ? (
            <>
              <span className="text-muted" style={{ fontSize: "var(--text-sm)" }}>
                Conectado como <strong>{user?.username ?? "admin"}</strong> (JWT)
              </span>
              <button
                className="btn-secondary"
                style={{ fontSize: "var(--text-xs)", padding: "var(--space-1) var(--space-3)" }}
                onClick={handleLogout}
              >
                Sair
              </button>
            </>
          ) : (
            <Link to="/login?perfil=admin" className="btn" style={{ fontSize: "var(--text-xs)" }}>
              Fazer Login Admin
            </Link>
          )}
        </div>
      </div>

      <nav className="admin-nav">
        <Link to="catalogo">Catálogo</Link>
        <Link to="colecoes">Coleções</Link>
        <Link to="categorias">Categorias</Link>
        <Link to="pedidos">Pedidos / Pix</Link>
        <Link to="cupons">Cupons</Link>
        <Link to="tenants">Tenants</Link>
        <Link to="licencas">Licenças</Link>
        <Link to="colaboradores">Colaboradores</Link>
        <Link to="relatorios">Relatórios</Link>
        <Link to="auditoria">Auditoria</Link>
        <Link to="administradores">Administradores</Link>
        <Link to="emails">E-mails</Link>
        <Link to="configuracao">Configuração</Link>
      </nav>
      <Outlet />
    </div>
  );
}
